import { render, staticRenderFns } from "./PlatformStatementList.vue?vue&type=template&id=54fd71a2&"
import script from "./PlatformStatementList.vue?vue&type=script&lang=js&"
export * from "./PlatformStatementList.vue?vue&type=script&lang=js&"
import style0 from "./PlatformStatementList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports